const KEY_PENDING_REDIRECT = "login_redirect_pending_target";

/**
 * Guard against /login?redirect_url=<target> ping-pong.
 *
 * The sign-in page sends an already-authenticated visitor straight to
 * `redirect_url`. If the stored token turns out to be unusable, the target page
 * bounces back to /login with the same `redirect_url` and the two pages redirect
 * each other forever. Remembering the target we last bounced to lets sign-in
 * detect the second attempt and fall back to logging the user out instead.
 *
 * The marker is cleared once an authenticated page finishes bootstrapping (see
 * `withAuth`), so a genuine "back button to /login" round trip keeps working.
 */
export const markPendingLoginRedirect = (target: string) => {
  try {
    sessionStorage.setItem(KEY_PENDING_REDIRECT, target);
  } catch (e) {
    // Private-mode storage failures must not block the redirect.
  }
};

export const hasPendingLoginRedirect = (target: string): boolean => {
  try {
    return sessionStorage.getItem(KEY_PENDING_REDIRECT) === target;
  } catch (e) {
    return false;
  }
};

export const clearPendingLoginRedirect = () => {
  try {
    sessionStorage.removeItem(KEY_PENDING_REDIRECT);
  } catch (e) {
    // Nothing to do.
  }
};
